import {Spinner, SpinnerSize, SpinnerStyle, SpinnerWeight} from '@mintdata-wsp/common/components/spinner/Spinner';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./GuideVideo.less');
const cx = classnames.bind(styles);

interface Props
{
}

interface State
{
    panelClientRect:ClientRect;
    showLoader:boolean;
}

@observer
export class GuideVideo extends React.Component<Props, State>
{
    constructor(props:any)
    {
        super(props);

        this.state = {
            panelClientRect: null,
            showLoader: true,
        };
    }

    componentDidMount():void
    {
        // reaction(
        //     () =>
        //     {
        //         const {video: guideVideo} = controllers.ui.guide.getGuideState();
        //
        //         return guideVideo ? guideVideo.panelRef : null;
        //     },
        //     (elementRef:HTMLElement) =>
        //     {
        //         this.setState({
        //             panelClientRect: elementRef ? elementRef.getBoundingClientRect() : null
        //         });
        //     }
        // );
    }

    private _onClickWrapper = () =>
    {
        controllers.ui.guide.setVideoVisibility(false);
        this.setState({showLoader: true});
    };

    private _onLoadIframe = () =>
    {
        this.setState({showLoader: false});
    };

    // private _renderText = (style:React.CSSProperties, text:string | JSX.Element):JSX.Element =>
    // {
    //     return (
    //         <div
    //             className={styles.textWrapper}
    //             style={style}
    //         >
    //             <div className={styles.text}>
    //                 {text}
    //             </div>
    //             <WSPIcon
    //                 className={styles.iconArrow}
    //                 name={WSPIcons.guide.Arrow}
    //             />
    //         </div>
    //     );
    // };

    public render():JSX.Element
    {
        const {video: {isVisible, url}} = controllers.ui.guide.getGuideState();

        if( !isVisible || !url ) return null;

        // const aspectRatio:number = 16 / 9;
        const aspectRatio:number = 4 / 3;

        let _wrapperAspectStyle:React.CSSProperties = {
            maxWidth: `calc((100vh - 200px) * ${aspectRatio}`
        };

        let _wrapperStyle:React.CSSProperties = {
            paddingTop: `${100 / aspectRatio}%`
        };

        const {showLoader} = this.state;

        return (
            <div
                className={cx(styles.wrapper)}
                onClick={this._onClickWrapper}
            >
                <div className={cx(styles.videoWrapper1280)}>
                    <div
                        className={cx(styles.videoWrapperAspect)}
                        style={_wrapperAspectStyle}
                    >
                        <div
                            className={cx(styles.videoAspect)}
                            style={_wrapperStyle}
                        >
                            {
                                showLoader &&
                                <Spinner
                                    className={cx('spinner')}
                                    size={SpinnerSize.Large_64}
                                    style={SpinnerStyle.White}
                                    weight={SpinnerWeight.Normal}
                                />
                            }
                            <iframe
                                className={styles.video}
                                src={url}
                                frameBorder='0'
                                scrolling='no'
                                allowFullScreen
                                width='100%'
                                height='100%'
                                onLoad={this._onLoadIframe}
                            />

                            {/*<video*/}
                            {/*    className={styles.video}*/}
                            {/*    // src={'https://vimeo.com/493620712'}*/}
                            {/*    src={'https://assets.mintdata.com/website/product/surface_01.mp4'}*/}
                            {/*    controls={true}*/}
                            {/*    // playsInline={true}*/}
                            {/*    autoPlay={true}*/}
                            {/*    // muted={isMuted}*/}
                            {/*    // onClick={this._onVideoClick.bind(this)}*/}
                            {/*/>*/}
                        </div>
                        {/*<Video*/}
                        {/*    aspectRatio={16/9}*/}
                        {/*    // src={'https://vimeo.com/493620712'}*/}
                        {/*    // src={'http://techslides.com/demos/sample-videos/small.mp4'}*/}
                        {/*    src={'https://assets.mintdata.com/website/product/surface_01.mp4'}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        );
    }
}
